import{ axiosInstance} from "./axiosInstance";

export const getAllFestivalsData = () => axiosInstance.get("/admin/getFestival");

export const upsertHoliday = (postData) => axiosInstance.post("/admin/addFestival",postData);

export const editHoliday = (postData) => axiosInstance.put("/admin/editFestival",postData);

export const deleteHoliday = (_id) => axiosInstance.delete(`/admin/deleteFestival/${_id}`);
